/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupWithTeams
 */
export interface GroupWithTeams {
    /**
     * 
     * @type {string}
     * @memberof GroupWithTeams
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithTeams
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupWithTeams
     */
    bracket?: string;
}

/**
 * Check if a given object implements the GroupWithTeams interface.
 */
export function instanceOfGroupWithTeams(value: object): value is GroupWithTeams {
    return true;
}

export function GroupWithTeamsFromJSON(json: any): GroupWithTeams {
    return GroupWithTeamsFromJSONTyped(json, false);
}

export function GroupWithTeamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupWithTeams {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'bracket': json['bracket'] == null ? undefined : json['bracket'],
    };
}

export function GroupWithTeamsToJSON(json: any): GroupWithTeams {
    return GroupWithTeamsToJSONTyped(json, false);
}

export function GroupWithTeamsToJSONTyped(value?: GroupWithTeams | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'bracket': value['bracket'],
    };
}

